import { render, staticRenderFns } from "./DirectAppointmentSelectLocationPage.vue?vue&type=template&id=1d98a6a2"
import script from "./DirectAppointmentSelectLocationPage.vue?vue&type=script&lang=ts"
export * from "./DirectAppointmentSelectLocationPage.vue?vue&type=script&lang=ts"
import style0 from "./DirectAppointmentSelectLocationPage.vue?vue&type=style&index=0&id=1d98a6a2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports